<script lang="ts" setup>
import { Prop } from 'vue'

import { useAppStore } from '~/store/app/app'

import Top from '@/components/Sales/Sale/Top.vue'
import Bottom from '@/components/Sales/Sale/Bottom.vue'

/* Utils */
import { copyToClipboard } from '@/utils/copyToClipboard'

import { Sale } from '~/api/modules/sales/types'
import { SnackbarType } from '~/store/app/app.types'

const { showSnackbar } = useAppStore()

const props = defineProps({
  sale: {
    type: Object,
    required: true,
  } as Prop<Sale>,
})

// Проверяем промокод на наличие промо и активности
const checkActivityPromocode = (sale: Sale | undefined): boolean =>
  !sale ? false : Boolean(sale.code && !sale.archive)

const isVisiblePromocode = checkActivityPromocode(props.sale)
const isActive = props.sale?.code?.active || false

const copyCode = (promocode: string) => {
  const successful = copyToClipboard(promocode)

  if (successful) {
    showSnackbar({
      message: 'Промокод скопирован',
      type: SnackbarType.SUCCESS,
    })
  }
}
</script>

<template>
  <div v-if="sale" class="sale__item">
    <top
      :image="sale.image || ''"
      :title="sale.title"
      :link-sale="sale?.slug || ''"
      :archive="!!sale?.archive"
    />

    <bottom
      :is-visible-promocode="isVisiblePromocode"
      :is-active-code="isActive"
      :code="sale.code"
      :short-description="sale.short_description"
      @copy-code="copyCode"
    />
  </div>
</template>

<style lang="scss" scoped>
.sale__item {
  display: grid;
  grid-template-rows: max-content 1fr;
  grid-template-columns: 100%;
  justify-content: space-between;
}
</style>
